<script setup>
import { Inertia } from '@inertiajs/inertia';
import { defineProps, reactive, watch, ref} from 'vue';
import { useForm } from "@inertiajs/inertia-vue3";
import Tiptap from '@/Shared/Editors/Tiptap.vue'
import ArrowLeftIcon from "@/Shared/SVG/ArrowLeftIcon";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

let props = defineProps({
    errors: Object,
    blogTypes: Object,
});

let form = useForm({
    title: null,
    type: null,
    content: null,
    meta_desc: null,
    is_published: true,
    force_order: false,
    tags: null,
})

let imageInput = ref();
let imageUrl = reactive({url: null});
let coverInput = ref();
let coverUrl = reactive({url: null});

function submit() {
    if (imageInput.value) {
        form.image = imageInput.value.files[0];
    }
    if (coverInput.value) {
        form.cover = coverInput.value.files[0];
    }
    Inertia.post('/backoffice/blogs', form)
}

function previewImage(e) {
    let file = e.target.files[0];
    imageUrl.url = URL.createObjectURL(file);
}
function previewCover(e) {
    let file = e.target.files[0];
    coverUrl.url = URL.createObjectURL(file);
}
</script>

<template>
    <div class="max-w-7xl mx-auto px-4 flex justify-between items-center">
        <h1 class="text-2xl font-semibold text-gray-900">Blogs</h1>
        <Link href="/backoffice/blogs" class="text-sm text-wgn-blue-4 flex items-baseline"><ArrowLeftIcon class="mr-1 w-3 h-3"></ArrowLeftIcon>Back To Blogs</Link>
    </div>
    <hr class="my-3">
    <div class="max-w-7xl mx-auto px-4 text-sm">
        <form @submit.prevent="submit">
            <div class="mt-2">
                <label for="title" class="font-bold">Title</label>
                <input type="text" v-model="form.title" class="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"/>
                <div v-if="errors.title" class="font-bold text-red-600">
                    {{ errors.title }}
                </div>
            </div>
            <div class="mt-2">
                <label for="type" class="font-bold">Type</label>
                <vSelect id="type" v-model="form.type" class="bg-white col-span-2" :options="blogTypes" label="label" :reduce="label => label.value"></vSelect>
                <div v-if="errors.type" class="font-bold text-red-600">
                    {{ errors.type }}
                </div>
            </div>
            <div class="mt-2">
                <label for="content" class="font-bold">Content</label>
                <tiptap v-model="form.content" :allowTable="false"/>
                <div v-if="errors.content" class="font-bold text-red-600">
                    {{ errors.content }}
                </div>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Meta Description</label>
                <textarea
                    name="answer"
                    type="text"
                    v-model="form.meta_desc"
                    class="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600">
                </textarea>
                <div v-if="errors.meta_desc" class="font-bold text-red-600">
                    {{ errors.meta_desc }}
                </div>
            </div>
            <div class="mt-2">
                <label for="is_published" class="font-bold">Publish</label>
                <input
                    type="checkbox"
                    name="is_published"
                    v-model="form.is_published"
                    class="mx-2 border rounded-md border-gray-500"
                />
                <div v-if="errors.is_published" class="font-bold text-red-600">
                    {{ errors.is_published }}
                </div>
            </div>
            <div class="mt-2">
                <label for="force_order" class="font-bold">Force Order</label>
                <input
                    type="checkbox"
                    name="force_order"
                    v-model="form.force_order"
                    class="mx-2 border rounded-md border-gray-500"
                />
                <div v-if="errors.force_order" class="font-bold text-red-600">
                    {{ errors.force_order }}
                </div>
            </div>
            <div class="mt-2">
                <label for="cover" class="font-bold">Cover</label>
                <img v-show="coverUrl.url" :src="coverUrl.url" alt="cover" class="mt-1 h-80 border rounded-md border-gray-500"/>
                <input type="file"
                       v-on:change="previewCover"
                       ref="coverInput"
                       class="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"/>
                <div v-if="errors.cover" class="font-bold text-red-600">
                    {{ errors.cover }}
                </div>
            </div>
            <div class="mt-2">
                <label for="image" class="font-bold">Image</label>
                <img v-show="imageUrl.url" :src="imageUrl.url" alt="image" class="mt-1 h-80 border rounded-md border-gray-500"/>
                <input type="file"
                       v-on:change="previewImage"
                       ref="imageInput"
                       class="w-full px-4 py-2 ?hnhmt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"/>
                <div v-if="errors.image" class="font-bold text-red-600">
                    {{ errors.image }}
                </div>
            </div>
            <div class="mt-2">
                <label for="tags" class="font-bold">Tags</label>
                <vSelect taggable multiple id="tags" v-model="form.tags" label="tag" class="bg-white col-span-2"></vSelect>
                <div v-if="errors.tags" class="font-bold text-red-600">
                    {{ errors.tags }}
                </div>
            </div>

            <div class="flex items-center mt-4">
                <button class="px-6 py-2 text-white bg-gray-900 rounded">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
import BackofficeLayout from '@/Layouts/BackofficeLayout'
export default {
    layout: BackofficeLayout,
}
</script>
